import { BitmapText, Text } from "pixi.js";
import { Tween } from "tweedle.js";
import { betValueGlobal } from "./config/GlobalVariableConfig";

export function isFireFox(): boolean {
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    if (/firefox/i.test(ua)) return true;

    const uaData = (navigator as any).userAgentData;
    if (uaData?.brands?.some((b: any) => /firefox/i.test(b.brand))) return true;
    if (uaData?.platform === 'Android' && uaData?.brands?.some((b: any) => /firefox/i.test(b.brand))) return true;
    return typeof (window as any).InstallTrigger !== 'undefined';
}

export function getCoordinates(offset: number, isStartFromZero: boolean = true) {
    const adjustedOffset = (isStartFromZero) ? offset : offset - 1;
    const row = Math.floor(adjustedOffset / 5);
    const col = adjustedOffset % 5;
    return { row, col };
}

export async function wait(ms: number) {
    return new Promise((resolve) => {
        new Tween({})
            .delay(ms)
            .onAfterDelay(resolve) // Resolve the promise when delay ends
            .start();
    });
}

// export function customSort(arr: number[][]) {
//     arr.sort((a, b) => {
//         if (a[1] !== b[1]) {
//             return a[1] - b[1];
//         }
//         return a[0] - b[0];
//     });
//     return arr;
// }

export function customSortColumnWise(arr: number[][]) {
    arr.sort((a, b) => {
        if (a[0] !== b[0]) {
            return a[0] - b[0];
        }
        return a[1] - b[1];
    });
    return arr;
}


type FitOptions = {
    maxWidth: number;
    minFontSize?: number;
};

export function fitTextToWidth(obj: Text | BitmapText, options: FitOptions) {
    const maxWidth = options.maxWidth;
    const minFontSize = options.minFontSize ?? 10;

    if (obj instanceof Text) {
        obj.style.wordWrap = false;
        obj.style.whiteSpace = "pre";
    }

    let fontSize = obj instanceof Text ? (obj.style.fontSize as number) : obj.style.fontSize;

    if (obj.width <= maxWidth) return;

    const ratio = maxWidth / obj.width;
    let newSize = Math.floor(fontSize * ratio);
    newSize = Math.max(newSize, minFontSize);

    applyFontSize(obj, newSize);

    while (obj.width > maxWidth && newSize > minFontSize) {
        newSize--;
        applyFontSize(obj, newSize);
    }
}

function applyFontSize(obj: Text | BitmapText, size: number) {
    if (obj instanceof Text) {
        obj.style.fontSize = size;
    } else {
        obj.style.fontSize = size;
    }
}

export function fitTextWithScale(obj: Text | BitmapText, maxWidth: number) {
    const scale = Math.min(maxWidth / obj.width, 1);
    obj.scale.set(scale, scale); // Apply scaling
}

export function checkIsBigWin(winAmt: number): boolean {
    if (winAmt && winAmt < 20 * betValueGlobal) {
        return false;
    } else {
        return true;
    }
}
